module.exports = __webpack_public_path__ + "img/star.43db9c6.png";